import * as idsApis from '@maxtropy/intelligent-dispath-apis-v2';

const IDS_API_PREFIX_REWRITES: Array<[string, string]> = [
  ['/api/v2/physical-model', '/api/v2/ids/physical-model'],
  ['/api/v2/customer-user', '/api/v2/ids/customer-user'],
  ['/api/v2/bsa-strategy', '/api/v2/ids/bsa-strategy'],
  ['/api/v2/file-center', '/api/v2/ids/file-center'],
  ['/api/v2/deviceProperty', '/api/v2/ids/deviceProperty'],
  ['/api/customer-user', '/api/ids/customer-user'],
  ['/api/deviceProperty', '/api/ids/deviceProperty'],
  ['/api/physical-model', '/api/ids/physical-model'],
  ['/api/file-center', '/api/ids/file-center'],
  ['/api/v2/device', '/api/v2/ids/device'],
  ['/api/v2/staff', '/api/v2/ids/staff'],
  ['/api/v2/bsa', '/api/v2/ids/bsa'],
  ['/api/v2/uet', '/api/v2/ids/uet'],
  ['/api/v2/ou', '/api/v2/ids/ou'],
  ['/api/device', '/api/ids/device'],
  ['/api/staff', '/api/ids/staff'],
];

const rewriteIdsApiPath = (path?: string) => {
  if (!path || path.includes('/api/ids/') || path.includes('/api/v2/ids/')) return path;

  const matched = IDS_API_PREFIX_REWRITES.find(([from]) => path === from || path.startsWith(`${from}/`));
  if (!matched) return path;

  const [from, to] = matched;
  return `${to}${path.slice(from.length)}`;
};

Object.values(idsApis).forEach(api => {
  const requestConfig = (api as { requestConfig?: { path?: string } }).requestConfig;
  if (!requestConfig?.path) return;

  requestConfig.path = rewriteIdsApiPath(requestConfig.path);
});
